const menus = [
  { name: "ABOUT", path: "https://buakaw.club/en/#about" },
  { name: "ROADMAP", path: "https://buakaw.club/en/#roadmap" },
  { name: "PARTNERS", path: "https://buakaw.club/en/#partners" },
  { name: "FAQs", path: "https://buakaw.club/en/#faq" },
  { name: "OPENSEA", path: "https://opensea.io/collection/buakaw1" },
];

export default menus;
